import React from 'react';
import CityCard from '../CityCard';
import { Bot } from 'lucide-react';
import { GAME_MODES } from '../../mock/gameData';

const PlayerHand = ({ 
  playerType, 
  playerName,
  cards, 
  tricks, 
  selectedCard,
  isPlayable,
  deckColors,
  onCardClick,
  gameMode,
  aiInfo,
  className = "mb-6"
}) => {
  const isPlayer1 = playerType === 'player1';
  const tricksColor = isPlayer1 ? 'bg-blue-700/80 border-blue-300' : 'bg-purple-700/80 border-purple-300';
  
  return (
    <div className={className}>
      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            {!isPlayer1 && gameMode === GAME_MODES.HUMAN_VS_COMPUTER ? (
              <>
                <Bot className="w-5 h-5" />
                <span className={aiInfo?.color}>{aiInfo?.name}</span>
                <span className="text-lg">{aiInfo?.icon}</span>
              </>
            ) : (
              playerName
            )}
          </h2>
          <div className={`${tricksColor} text-white px-4 py-2 rounded-lg border`}>
            <span className="text-4xl font-bold">{tricks}</span>
          </div>
        </div>
        <div className="flex gap-2 flex-wrap justify-center">
          {cards.map((card) => (
            <CityCard 
              key={card.id} 
              card={card}
              isSelected={selectedCard?.id === card.id}
              isPlayable={isPlayable}
              showRank={false}
              deckColors={deckColors}
              onClick={() => onCardClick && onCardClick(card)}
              className="transform transition-all duration-300"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlayerHand;